import { CommonOptionVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"

export class SectionOptionsVM extends CommonOptionVM {
  grouped_item_id?: string
  image_marker_id?: string

  constructor(data: Partial<SectionOptionsVM> = {}) {
    super(data)
    this.grouped_item_id = data.grouped_item_id ?? undefined
    this.image_marker_id = data.image_marker_id ?? undefined
  }

  validateData() {
    const errors: any[] = []
    // if (true) {
    //   errors.push({key: 'key_name', error_message: 'error_message'})
    // }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default SectionOptionsVM
